var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.searchActive && _vm.isLoading)?_c('el-dropdown-item',{staticClass:"no-hover"},[_c('loading-placeholder',{attrs:{"lines":3}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }